<template>
  <base-modal :show="showModal" @controleModalApperance="$emit('closeModal')">
    <template #modal>
      <div class="modal_card">
        <div class="modal_header">
          <h5>{{ $t("chatbotFaqs.faqDetails") }}</h5>
          <button class="close_btn" @click="$emit('closeModal')">
            <i class="fal fa-times"></i>
          </button>
        </div>

        <div class="modal_body">
          <div class="faq_detail_wrapper" v-if="faqData">
            <div class="row">
              <!-- Start:: Question AR -->
              <div class="col-12 mb-3">
                <label class="d-block mb-1 font-weight-bold">{{
                  $t("chatbotFaqs.questionAr")
                }}</label>
                <p class="detail_text">{{ faqData.question_ar || "-" }}</p>
              </div>
              <!-- End:: Question AR -->

              <!-- Start:: Answer AR -->
              <div class="col-12 mb-3">
                <label class="d-block mb-1 font-weight-bold">{{
                  $t("chatbotFaqs.answerAr")
                }}</label>
                <p class="detail_text">{{ faqData.answer_ar || "-" }}</p>
              </div>
              <!-- End:: Answer AR -->

              <!-- Start:: Question EN -->
              <div class="col-12 mb-3">
                <label class="d-block mb-1 font-weight-bold">{{
                  $t("chatbotFaqs.questionEn")
                }}</label>
                <p class="detail_text">{{ faqData.question_en || "-" }}</p>
              </div>
              <!-- End:: Question EN -->

              <!-- Start:: Answer EN -->
              <div class="col-12 mb-3">
                <label class="d-block mb-1 font-weight-bold">{{
                  $t("chatbotFaqs.answerEn")
                }}</label>
                <p class="detail_text">{{ faqData.answer_en || "-" }}</p>
              </div>
              <!-- End:: Answer EN -->

              <!-- Start:: Tags -->
              <div
                class="col-12 mb-3"
                v-if="faqData.tags && faqData.tags.length"
              >
                <label class="d-block mb-1 font-weight-bold">{{
                  $t("chatbotFaqs.tags")
                }}</label>
                <div class="tags_list">
                  <span
                    v-for="(tag, index) in faqData.tags"
                    :key="index"
                    class="tag_item"
                  >
                    {{ tag }}
                  </span>
                </div>
              </div>
              <!-- End:: Tags -->

              <!-- Start:: Status -->
              <div class="col-12 mb-3">
                <label class="d-block mb-1 font-weight-bold">{{
                  $t("chatbotFaqs.status")
                }}</label>
                <span
                  class="status_badge"
                  :class="{
                    'text-success': faqData.is_active,
                    'text-danger': !faqData.is_active,
                  }"
                >
                  {{
                    faqData.is_active
                      ? $t("chatbotFaqs.active")
                      : $t("chatbotFaqs.inactive")
                  }}
                </span>
              </div>
              <!-- End:: Status -->
            </div>
          </div>
        </div>
      </div>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from "@/components/ui/BaseModal.vue";

export default {
  name: "ChatbotFaqDetail",

  components: {
    BaseModal,
  },

  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    faqData: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style scoped lang="scss">
.modal_card {
  background: white;
  border-radius: 12px;
  max-width: 700px;
  width: 90vw;
  max-height: 90vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .modal_header {
    padding: 20px 25px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h5 {
      margin: 0;
      font-size: 18px;
      font-weight: 600;
    }

    .close_btn {
      background: none;
      border: none;
      font-size: 20px;
      cursor: pointer;
      color: #999;
      padding: 5px 10px;

      &:hover {
        color: #333;
      }
    }
  }

  .modal_body {
    overflow-y: auto;
    flex: 1;
  }
}

.faq_detail_wrapper {
  padding: 20px;

  label {
    font-size: 14px;
    color: #666;
  }

  .detail_text {
    font-size: 15px;
    color: #333;
    margin: 0;
  }

  .tags_list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;

    .tag_item {
      padding: 5px 12px;
      background: #e3f2fd;
      border-radius: 4px;
      font-size: 13px;
      color: #1976d2;
    }
  }

  .status_badge {
    padding: 4px 12px;
    border-radius: 4px;
    font-weight: 500;
    font-size: 13px;
  }
}
</style>
